import { Component, Injector } from '@angular/core';
import { NavigationEnd, NavigationStart, Router, RouteReuseStrategy } from '@angular/router';
import { AppConfigService } from '../../core/services/config.service';
import { AppTranslationLoaderService } from 'src/app/core/services/translation-loader.service';
import { LogService } from '../content/sections/websocketclient/notification.services';
import { NotificationService } from '../../core/services/notification/notification.service';
import { ApplicationInfoService } from '../../core/translate/application-info.service';
import { TransactionResult } from '../../core/services/interfaces/transaction-result';
import { AppsInfo } from '../../core/translate/models/app-info';
import { environment } from '../../../environments/environment';
import { TranslateApplicationService } from '../../core/translate/translate-application-service';
import { Application } from '../../core/translate/models/application';
import { MsAdalAngular6Service } from '@jabilcore/microsoft-adal-angular6';
import { CognitoService } from '../../core/services/cognito/cognito.service';
import { AuthService } from '../../core/services/authentication/auth.service';


@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss']
})

export class AppToolbarComponent {
  userStatusOptions: any[];
  languages: Array<any> = [];
  selectedLanguage: any;
  showLoadingBar: boolean;
  horizontalNav: boolean;
  username: string;
  name: string;
  windowsNT: string;
  local: string;
  employeeNumber: string;
  appName: string;
  appVersion: string;
  private adal: MsAdalAngular6Service;
  loginType: number = window["loginType"];

  constructor(
    private router: Router,
    private appConfig: AppConfigService,
    private translate: TranslateApplicationService,
    private cognitoService: CognitoService,
    private authService: AuthService,
    private applications: ApplicationInfoService,
    //private logService: LogService,
    private notification: NotificationService,
    private injector: Injector
  ) {
    if (this.loginType == 1) {
      this.adal = <MsAdalAngular6Service>this.injector.get(MsAdalAngular6Service);

      this.appName = window["configuration"].adalConfiguration.applicationName;
      this.appVersion = window["configuration"].adalConfiguration.applicationVersion;
    }
    else {
      this.appName = window["configuration"].applicationName;
      this.appVersion = window["configuration"].applicationVersion;
    }


    this.languages = applications.languages;

    if (this.languages.length == 0) {
      this.languages.push({
        id: 1,
        title: 'English',
        flag: 'en',
        applicationId: 0
      });

      this.languages.push({
        id: 1,
        title: 'Spanish',
        flag: 'es',
        applicationId: 0
      });

    }

    this.selectLanguage();

    router.events.subscribe(
      (event) => {
        if (event instanceof NavigationStart) {
          this.showLoadingBar = true;
        }
        if (event instanceof NavigationEnd) {
          this.showLoadingBar = false;
        }
      });

    this.appConfig.onSettingsChanged.subscribe((settings) => {
      this.horizontalNav = settings.layout.navigation === 'top';
    });

    switch (this.loginType) {
      case 1:
        if (this.adal.isAuthenticated) {
          this.username = this.adal.userInfo.userName;
          this.name = this.adal.userInfo.profile.nameComplete;
          this.windowsNT = this.adal.userInfo.profile.WindowsNT;
          this.employeeNumber = this.adal.userInfo.profile.unique_name;
        }
        break;
      case 2:
        if (this.cognitoService.IsAuhtenticated()) {
          this.cognitoService.getUserInfo().subscribe(result => {
            this.username = result['email'];
          });
        }
        break;
      case 3:
        if (this.authService.isAuthenticated()) {
          this.username = this.authService.user.email;
          this.name = this.authService.user.name;
          this.windowsNT = this.authService.user.userName;
          this.local = this.authService.user.siteName;
        }
        break;
    }

    /*logService.messages.subscribe(msg => {
      this.notification.addAlert(
        {
          icon: 'all_inbox',
          title: 'Track',
          message: msg,
          shown: true
        }
      )
    });*/
  }

  selectLanguage(): void {
    let indexLang = 0;
    if (this.languages != undefined) {
      if (navigator.language.split('-').length > 0) {
        indexLang = this.languages.findIndex(lang => lang.flag === navigator.language.split('-')[0]);
      }
      else {
        indexLang = this.languages.findIndex(lang => lang.flag === navigator.language);
      }

      if (indexLang < 0) {
        this.selectedLanguage = this.languages[0];
      } else {
        this.selectedLanguage = this.languages[indexLang];
      }

      this.setLanguage(this.selectedLanguage);
    }
  }

  setLanguage(lang) {
    // Set the selected language for toolbar
    this.selectedLanguage = lang;
    // selected language for translations
    this.translate.use(lang);
  }

  logOut(): void {
    switch (this.loginType) {
      case 1:
        if (this.adal.isAuthenticated)
          this.adal.logout();
        break;
      case 2:
        if (this.cognitoService.IsAuhtenticated())
          this.cognitoService.logOut();
        break;
      case 3:
        if (this.authService.isAuthenticated())
          this.authService.logAuth();
        break;
    }
  }
}
